import Num from '@flipster/utils/num';

export const getVIPEstimatedApr = (estimatedApr?: string, vipMultiplier?: number) => {
  if (!(estimatedApr && vipMultiplier)) return undefined;
  return Num(estimatedApr).decimalPlaces(2).multipliedBy(vipMultiplier).toNumber();
};
